export const API_BASE_URL = "https://furniture-store.b.goit.study/api";

export const API_ENDPOINTS = {
    FURNITURES: "/furnitures",
    CATEGORIES: "/categories",
    ORDERS: "/orders",
    FEEDBACKS: "/feedbacks",
}

export const ITEMS_PER_PAGE = 8;
